import { Grid, Hidden } from "@material-ui/core";
import { Fragment, useEffect } from "react";
import { getLS } from "../../../../utils/useLS";
import InvoicesMain from "../invoiceMain";
import RestInvoice from "../InvoiceRest/InvoiceRest";
import InvoiceOilMain from "../InvoiceOil/InvoiceOilMain";

export default function InvoicesScreen(props) {
  let locR = getLS("DataRem", {});
  const { AutoOptions, isPurches, isStock, isMake, isDialog, invtype,
    isOrder,orderProceId ,orderId} = props;

  if (AutoOptions?.permType?.id === 3 && invtype === 0) return <RestInvoice
    {...{
      AutoOptions,
      isPurches,
      isStock,
      isMake,
      isDialog,
      fromInv: true,
      isOrder,orderProceId ,orderId

    }}
  />;

  if ((AutoOptions?.permType?.id === 4 ||AutoOptions?.permType?.id === 5 )&& invtype === 0)
    return (
      //  <InvoicesMain
      <>
        <Hidden only={["xs"]}>
          <InvoicesMain
            {...{
              AutoOptions,
              isPurches: invtype == 3 || invtype == 4 || invtype == 6 ? true : false,
              isStock: invtype == 5 || invtype == 7 ? true : false,
              isMake: invtype == 7 ? false : false,
              isDialog: false,
              isOrder,orderProceId ,orderId
            }}
          />
        </Hidden>
        <Hidden smUp={["sm"]}>
          <InvoiceOilMain
            {...{
              AutoOptions,
              isPurches: invtype == 3 || invtype == 4 || invtype == 6 ? true : false,
              isStock: invtype == 5 || invtype == 7 ? true : false,
              isMake: invtype == 7 ? false : false,
              isDialog: false,
              isOrder,orderProceId ,orderId
            }}
          />
        </Hidden>
  
      </>
  
    );


  return <InvoicesMain
    {...{
      AutoOptions,
      isPurches,
      isStock,
      isMake,
      isDialog,
      isOrder,orderProceId ,orderId
    }}
  />;
}
